<section *ngIf="questions">
  <div class="flex-container">
    <div class="flex-row flex-justify-center">
      <div class="flex-col-6 flex-col-md-6 flex-col-sm-12">
        <form [formGroup]="form">
          <div class="white-box">
            <div class="progress">
              <div
                class="bar"
                *ngFor="let question of questions"
                [class.active]="question.inyova_id <= questionNumber"
                [class.enabled]="savedAnswers[question.inyova_id - 1]"
                [style.width.%]="100 / questions.length"
                (click)="prev(question.inyova_id)"
              ></div>
            </div>
            <ng-container *ngIf="questionNumber <= questions.length; else thankYou">
              <p class="subtitle">
                {{ 'survey.subtitle' | translate }}
                {{
                  'survey.question.totalNumber' | translate: { questionNumber: questionNumber, totalNumberOfQuestions: questions.length }
                }}
              </p>
              <ng-container *ngFor="let question of questions">
                <p class="question" *ngIf="questionNumber === question.inyova_id">{{ question.question_text }}</p>
                <p class="question-hint" *ngIf="question.type === 'multichoice' && questionNumber === question.inyova_id">
                  {{ 'survey.multiple' | translate }}
                </p>
                <div *ngIf="question.type === 'singlechoice' && questionNumber === question.inyova_id" class="chips">
                  <div
                    class="option"
                    *ngFor="let option of question.survey_answer_options"
                    [ngClass]="form.get('q1').value === option.id ? 'active' : ''"
                  >
                    <label>
                      <input type="radio" [formControlName]="'q' + question.inyova_id" [value]="option.id" />
                      {{ option.option_text }}
                    </label>
                  </div>
                </div>
                <div *ngIf="question.type === 'open' && questionNumber === question.inyova_id" class="multi">
                  <textarea [formControlName]="'q' + question.inyova_id" [placeholder]="'survey.placeholder' | translate"></textarea>
                </div>
                <div *ngIf="question.type === 'multichoice' && questionNumber === question.inyova_id" class="chips">
                  <div
                    class="option"
                    *ngFor="let answer of question.survey_answer_options"
                    [ngClass]="{ active: inList(question.inyova_id, answer.id) }"
                  >
                    <label>
                      <input type="checkbox" (change)="onSelectChange(question.inyova_id, answer.id)" [value]="answer.id" />
                      {{ answer.option_text }}
                    </label>
                  </div>
                </div>
                <div *ngIf="question.type === 'rating' && questionNumber === question.inyova_id">
                  <div class="chips inline-chips">
                    <div
                      class="option"
                      *ngFor="let score of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
                      [ngClass]="{ active: form.get('q' + questionNumber).value === score }"
                    >
                      <label>
                        <input type="radio" [formControlName]="'q' + question.inyova_id" [value]="score" />
                        {{ score }}
                      </label>
                    </div>
                  </div>
                  <div class="chips-help">
                    <div>{{ question.low_tip }}</div>
                    <div>{{ question.high_tip }}</div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
            <ng-template #thankYou>
              <h2>{{ 'survey.thanks.title' | translate }}</h2>
              <p>{{ 'survey.thanks.p' | translate }}</p>
              <div class="final">
                <img src="/assets/images/cactus.png" />
              </div>
            </ng-template>
          </div>
          <div class="ui-button-group">
            <ng-container *ngIf="questionNumber <= questions.length; else showFinish">
              <button *ngIf="questionNumber !== 1" (click)="prev(questionNumber - 1)" class="ui-button secondary" type="button">
                {{ 'general.back' | translate }}
              </button>
              <button (click)="next()" class="ui-button" type="button" [disabled]="form.get('q' + questionNumber).invalid">
                {{ (questionNumber < questions.length ? 'survey.continue' : 'survey.finish') | translate }}
              </button>
            </ng-container>
            <ng-template #showFinish>
              <button (click)="finish()" type="button" class="ui-button">
                {{ 'survey.thanks.cta' | translate }}
              </button>
            </ng-template>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
<app-exit-survey-modal *ngIf="exitModal"></app-exit-survey-modal>
